(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alm-category-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const revealCategories = (scope = document) => {
      const sections = [...scope.querySelectorAll('.alm-categories:not([data-alm-reveal-ready])')];

      if (scope.matches && scope.matches('.alm-categories:not([data-alm-reveal-ready])')) {
        sections.unshift(scope);
      }

      sections.forEach((section) => {
        section.dataset.almRevealReady = 'true';

        if (reduceMotion.matches || !('IntersectionObserver' in window)) {
          section.classList.add('alm-categories--visible');
          return;
        }

        section.classList.add('alm-categories--motion-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('alm-categories--visible');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.16,
            rootMargin: '0px 0px -8% 0px'
          }
        );

        observer.observe(section);
      });
    };

    revealCategories();

    document.addEventListener('shopify:section:load', (event) => {
      revealCategories(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alm-store-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const storySections = new Set();
    let animationFrame;

    const updateParallax = () => {
      animationFrame = null;

      if (reduceMotion.matches) return;

      const viewportHeight = window.innerHeight;
      const mobile = window.innerWidth <= 768;
      const maxShift = mobile ? 14 : 26;

      storySections.forEach((section) => {
        const rect = section.getBoundingClientRect();

        if (rect.bottom < 0 || rect.top > viewportHeight) return;

        const viewportCenter = viewportHeight / 2;
        const sectionCenter = rect.top + rect.height / 2;
        const travel = (viewportHeight + rect.height) / 2;
        const progress = Math.max(-1, Math.min(1, (viewportCenter - sectionCenter) / travel));
        const shift = progress * maxShift;

        section.style.setProperty('--alm-story-main-shift', `${shift * -0.65}px`);
        section.style.setProperty('--alm-story-detail-one-shift', `${shift * 0.42}px`);
        section.style.setProperty('--alm-story-detail-two-shift', `${shift * -0.3}px`);
      });
    };

    const requestParallaxUpdate = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(updateParallax);
    };

    const initializeStories = (scope = document) => {
      const sections = [...scope.querySelectorAll('.alm-story:not([data-alm-story-ready])')];

      if (scope.matches && scope.matches('.alm-story:not([data-alm-story-ready])')) {
        sections.unshift(scope);
      }

      sections.forEach((section) => {
        section.dataset.almStoryReady = 'true';
        storySections.add(section);

        if (reduceMotion.matches || !('IntersectionObserver' in window)) {
          section.classList.add('alm-story--visible');
          return;
        }

        section.classList.add('alm-story--motion-ready');

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('alm-story--visible');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.14,
            rootMargin: '0px 0px -6% 0px'
          }
        );

        observer.observe(section);
      });

      requestParallaxUpdate();
    };

    initializeStories();
    window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
    window.addEventListener('resize', requestParallaxUpdate);

    document.addEventListener('shopify:section:load', (event) => {
      initializeStories(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('.alm-story');
      if (section) storySections.delete(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
